<template>
  <div>
    <el-drawer
      v-if="visible"
      visible
      show-close
      :size="1000"
      :title="title"
      :close-on-click-modal="false"
      :before-close="() => $refs.main.cancel()"
    >
      <div class="drawer-main">
        <Main
          ref="main"
          :disabled="disabled"
          :custBizTeamSetCode="custBizTeamSetCode"
          @close="close"
          @reload="$emit('reload')"
        />
      </div>
      <div class="d-flex justify-content-end" style="padding: 4px 20px 20px;">
        <el-button size="small" @click="$refs.main.cancel()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          v-if="!disabled"
          type="primary"
          size="small"
          @click="$refs.main.save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
import Main from './main.vue'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    custBizTeamSetCode: { type: String, default: '' },
  },
  data() {
    return {
      titleMap: {
        edit: this.$l('form_label_edit') || '编辑业务团队成员',
        detail: this.$l('form_label_detail') || '业务团队成员详情',
      },
    }
  },
  computed: {
    disabled() {
      return this.type === 'detail'
    },
    title() {
      return this.titleMap[this.type]
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.drawer-main {
  padding: 0 20px 10px;
}
</style>
